import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M3.378 14.216a2.5 2.5 0 0 1-1.811-.746 2.5 2.5 0 0 1-.746-1.81q0-1.045.746-1.79a2.5 2.5 0 0 1 1.811-.746q1.023 0 1.79.746.767.745.767 1.79 0 .703-.362 1.288a2.76 2.76 0 0 1-.927.927 2.44 2.44 0 0 1-1.268.341M12.492 14.216a2.5 2.5 0 0 1-1.811-.746 2.5 2.5 0 0 1-.746-1.81q0-1.045.746-1.79a2.5 2.5 0 0 1 1.81-.746q1.025 0 1.79.746.768.745.768 1.79 0 .703-.362 1.288a2.76 2.76 0 0 1-.927.927 2.44 2.44 0 0 1-1.268.341M21.605 14.216a2.5 2.5 0 0 1-1.81-.746 2.5 2.5 0 0 1-.747-1.81q0-1.045.746-1.79a2.49 2.49 0 0 1 1.811-.746q1.023 0 1.79.746.767.745.767 1.79 0 .703-.362 1.288a2.76 2.76 0 0 1-.927.927 2.44 2.44 0 0 1-1.268.341"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }